'use strict';

import Listing from './listing';

export default class LoadMoreListing extends Listing {
    constructor(el) {
        super(el);
        this.loadMoreElement = null;
        this.loadMoreSelector = '.js-listing-load-more';
    }

    loadMore() {
        if (!this.isLoading) {
            this.loadMoreElement.classList.add('is-loading');
            this.loadMoreElement.classList.add('btn--active');
            this.render(this.currentPage + 1, true).then(() => {
                this.loadMoreElement.classList.remove('is-loading');
                this.loadMoreElement.classList.remove('btn--active');
            });
        }
    }

    initPagination() {
        this.loadMoreElement = this.container.querySelector(this.loadMoreSelector);
        if (!this.isLastPage(this.loadMoreElement)) {
            this.showLoadMore();
        }
        this.loadMoreElement.addEventListener('click', this.loadMore.bind(this));
    }

    updatePagination(document) {
        let newLoadMoreElement = document.querySelector(this.loadMoreSelector);
        if (this.isLastPage(newLoadMoreElement)) {
            this.hideLoadMore();
        } else {
            this.showLoadMore();
        }
    }

    isLastPage(loadMoreElement) {
        return loadMoreElement.getAttribute('data-is-last') === 'True';
    }

    showLoadMore() {
        if (this.loadMoreElement) {
            this.loadMoreElement.classList.add('is-visible');
        }
    }

    hideLoadMore() {
        if (this.loadMoreElement) {
            this.loadMoreElement.classList.remove('is-visible');
        }
    }

    resetLoadMore() {
        if (this.loadMoreElement) {
            this.loadMoreElement.classList.remove('is-visible');
        }
    }

}



// WEBPACK FOOTER //
// ./app/components/listing/js/load-more-listing.js